<div *ngIf="showLoaderObs | async" class="position-bottom-right">
    <div>
        <mat-progress-spinner [strokeWidth]="2" [diameter]="25" [value]="5" mode="indeterminate"
            color="primary"></mat-progress-spinner>
        <div>
            <p *ngFor="let display of loaderDisplaysObs | async">{{ display }}</p>
        </div>
    </div>
</div>